import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { WebApiService } from "../../../_libs/web-api";
import { BaseWebApiService } from "./-base-webapi.service";

@Injectable({
	providedIn: "root"
})
export class MuleGetPlanService extends BaseWebApiService {
	constructor(private webApiService: WebApiService) {
		super();
	}

	public muleGetPlan(uri: string): Observable<any> {
		const url =
			"productCatalogMgmt/productOffering?product=broadband&groupBy=product&brand=dodo";

		return this.webApiService.getMuleGetPlan(
			this.valueReplacer(url, [""], [encodeURIComponent("".trim())])
		);
	}
}
